var render = function render(){var _vm=this,_c=_vm._self._c;return _c('details',{staticClass:"simple",attrs:{"open":""}},[_c('summary',[_vm._v("Top 25 Módulos")]),(_vm.items.length)?_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}}):_c('b-alert',{attrs:{"variant":"info","show":""}},[_vm._v(" No hay datos suficientes para mostrar la gráfica. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }